import Sidebar from './src/index.vue.mjs';
import SidebarItem from './src/sidebar-item.vue.mjs';
import './src/type.mjs';

const PlusSidebar = Sidebar;
const PlusSidebarItem = SidebarItem;

export { PlusSidebar, PlusSidebarItem };
